const locale = {
  TITLE: 'Visão Geral',
};

export default locale;
